const SEARCH_SYNTAX_CHARACTERS_REGEX = /["()+\-|~]/;
const BOOLEAN_OPERATOR_REGEX = /\b(?:AND|OR|NOT)\b/i;

export const toPartialMatchSearchText = (searchText?: string): string => {
  const trimmed = searchText?.trim();

  if (!trimmed || trimmed === '*') {
    return '*';
  }

  // Preserve explicit user-entered search syntax and wildcard expressions.
  if (
    trimmed.includes('*') ||
    SEARCH_SYNTAX_CHARACTERS_REGEX.test(trimmed) ||
    BOOLEAN_OPERATOR_REGEX.test(trimmed)
  ) {
    return trimmed;
  }

  return trimmed
    .split(/\s+/)
    .filter(Boolean)
    .map((token) => `${token}*`)
    .join(' ');
};